// extracted by mini-css-extract-plugin
export default {"sidebar":"PullRequestFileTree-module__sidebar--A_ZKx","FileTreeScrollable":"PullRequestFileTree-module__FileTreeScrollable--tm_BE"};